/**
 * Lớp vỏ ESM của `roles.cjs` — mọi định nghĩa nằm ở file .cjs bên cạnh.
 *
 * Vì sao tách đôi: luật "role bị khoá vùng" có một bất biến chống vòng lặp redirect
 * (`home` phải nằm trong chính `prefix` của nó) cần test canh, mà `node --test` chỉ
 * require được CommonJS. Giữ file .js này để mọi nơi vẫn `import { ... } from
 * "@/constants/roles"` như cũ, không phải sửa 7 chỗ import và không sinh bản sao thứ
 * hai của danh sách role.
 */
import roles from "./roles.cjs";

export const ROLE_ADMIN = roles.ROLE_ADMIN;
export const ROLE_STAFF = roles.ROLE_STAFF;
export const ROLE_ACCOUNTANT = roles.ROLE_ACCOUNTANT;

export const ROLE_LABELS = roles.ROLE_LABELS;
export const roleLabel = roles.roleLabel;
export const isKnownRole = roles.isKnownRole;

export const BUSINESS_ROLES = roles.BUSINESS_ROLES;
export const ACCOUNTING_ROLES = roles.ACCOUNTING_ROLES;
export const ORDER_BULK_ACTION_ROLES = roles.ORDER_BULK_ACTION_ROLES;
export const PRICE_WRITE_ROLES = roles.PRICE_WRITE_ROLES;
export const ORDER_ITEM_PRICE_WRITE_ROLES = roles.ORDER_ITEM_PRICE_WRITE_ROLES;
export const PAYMENT_WRITE_ROLES = roles.PAYMENT_WRITE_ROLES;
export const COD_WRITE_ROLES = roles.COD_WRITE_ROLES;
export const FREESHIP_WRITE_ROLES = roles.FREESHIP_WRITE_ROLES;

export const CONFINED_ROLE_AREAS = roles.CONFINED_ROLE_AREAS;
export const SHARED_ROUTE_PREFIXES = roles.SHARED_ROUTE_PREFIXES;

export const isSharedRoute = roles.isSharedRoute;
export const confinedRedirect = roles.confinedRedirect;
export const confinesOnPublicRoutes = roles.confinesOnPublicRoutes;
export const roleAllowed = roles.roleAllowed;
